import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, CheckCircle2, ArrowRight } from "lucide-react";
import { studio, eur, beDate } from "@/lib/studioApi";

const pill = (d) => {
  if (d < 0) return "bg-red-100 text-red-700";
  if (d <= 10) return "bg-amber-100 text-amber-800";
  return "bg-[#EEF2FF] text-[#3A5CC8]";
};

export const FiscalCalendar = () => {
  const [data, setData] = useState(null);
  useEffect(() => { studio.get("/finances/deadlines").then((r) => setData(r.data)).catch(() => setData(null)); }, []);
  if (!data?.items?.length) return null;
  const monthly = data.vat_period === "monthly";

  return (
    <section data-testid="fiscal-calendar" className="dv-card-in mt-4 rounded-2xl border border-[#E2E7F7] bg-white p-4 sm:p-5 shadow-[0_1px_2px_rgba(15,38,69,0.06)]">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-3">
          <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#EEF2FF] text-[#3A5CC8]"><CalendarClock className="h-5 w-5" /></span>
          <div className="min-w-0">
            <p className="font-heading text-[15px] font-bold text-[#0F2645]">{monthly ? "Prochaines échéances TVA (mensuelles)" : "Prochaines échéances TVA (trimestrielles)"}</p>
            <p data-testid="fiscal-calendar-rule" className="mt-0.5 text-xs text-[#5C6A87]">{data.text}</p>
          </div>
        </div>
        <Link to="/studio/finances" data-testid="fiscal-calendar-link" className="inline-flex items-center gap-1 text-sm font-semibold text-[#3A5CC8] hover:underline">Finances <ArrowRight className="h-4 w-4" /></Link>
      </div>
      <ul className="mt-4 divide-y divide-[#EEF1F8]">
        {data.items.map((it, i) => (
          <li key={it.start} data-testid={`fiscal-deadline-${i}`} className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 py-2.5">
            <div className="flex min-w-0 items-center gap-3">
              <span className={`inline-flex min-w-[64px] justify-center rounded-full px-2.5 py-1 text-[11px] font-bold tabular-nums ${pill(it.days_left)}`}>
                {it.days_left < 0 ? "dépassée" : it.days_left === 0 ? "aujourd'hui" : `J-${it.days_left}`}
              </span>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-[#0F2645]">{it.label} <span className="font-normal text-[#5C6A87]">· dépôt avant le {beDate(it.deadline)}</span></p>
                <p className="text-xs text-[#5C6A87]">
                  {it.status === "current" ? "Période en cours" : it.status === "closed" ? "Période close" : "Période à venir"}
                  {it.export_sent_at ? <span className="ml-2 inline-flex items-center gap-1 text-emerald-700"><CheckCircle2 className="h-3 w-3" /> export envoyé au comptable</span> : null}
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className={`font-mono text-sm font-bold tabular-nums ${it.net_position < 0 ? "text-emerald-700" : "text-[#0F2645]"}`} data-testid={`fiscal-net-${i}`}>{eur(Math.abs(it.net_position))}</p>
              <p className="text-[11px] text-[#5C6A87]">{it.net_position < 0 ? "à récupérer" : "à payer"}{it.estimated ? " (estimation)" : ""} · TVA facturée {eur(it.vat_due)} − déductible {eur(it.vat_deductible)}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
